/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import styled, { css } from 'styled-components'

import React from 'react'

export type TextTypes =
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'small'
  | 'four'
  | 'p'
  | 'pM'
  | 'nav'
  | 'two'
  | 'bTwo'
  | 'lOne'
  | 'one'
  | 'big'
  | 'smaller'
  | 'tiny'

export enum Fonts {
  DMSans = 'DM Sans',
}

export enum Weight {
  // Regular = '400',
  // Medium = '500',
  // Bold = '700',
  Light = '300',
  Regular = '400',
  Medium = '500',
  SemiBold = '600',
  Bold = '700',
  ExtraBold = '800',
  ExtraLargeBold = '900',
}

export enum TextSize {
  h2 = '42px',
  h3 = '48px',
  h4 = '40px',
  h5 = '25px',
  small = '12px',
  four = '14px',
  p = '16px',
  pM = '16px',
  nav = '18px',
  two = '20px',
  bTwo = '22px',
  lOne = '24px',
  one = '26px',
  big = '32px',
  smaller = '11px',
  tiny = '10px',
}

enum TextSizeMobile {
  h2 = '24px',
  h3 = '25px',
  h4 = '40px',
  h5 = '18px',
  small = '12px',
  four = '14px',
  p = '16px',
  pM = '13px',
  nav = '18px',
  two = '20px',
  bTwo = '22px',
  lOne = '24px',
  one = '26px',
  big = '32px',
  smaller = '11px',
  tiny = '10px',
}

interface CustomTextProps {
  type?: TextTypes
  weight?: Weight
  color?: string
  blur?: boolean
}

type TextProps = CustomTextProps & React.HTMLProps<HTMLParagraphElement>

export const Text = styled.span<TextProps>`
  font-family: ${Fonts.DMSans};
  font-weight: ${(props) => props.weight};
  color: ${(props) => props.color};
  ${(props) => getFontSizeByType(props.type || 'p')}
`

const getFontSizeByType = (type: TextTypes) => {
  return css`
    ${({ theme }) => theme.mediaWidth.Mobile`font-size: ${TextSizeMobile[type]}`};
    font-size: ${TextSize[type]};
  `
}
